import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Users from "./pages/Users";
import Earnings from "./pages/Earnings";
import Login from "./components/Login";
import axios from "axios";
import Sidenav from "./components/Sidenav";
import Pageauth from "./pages/Pageauth";
import ResetPassword from "./pages/ResetPassword";
import BuyProducts from "./pages/BuyProducts";
import Projects from "./pages/Projects";
import VisitDetails from "./pages/VisitDetails";
function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" />;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check token on app load
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Private routes */}

        <Route
          path="/"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <Projects />
            </PrivateRoute>
          }
        />
        <Route
          path="/auth"
          element={
            <PrivateRoute>
              <Pageauth />
            </PrivateRoute>
          }
        />

        <Route
          path="/visit"
          element={
            <PrivateRoute>
              < VisitDetails />
            </PrivateRoute>
          }
        />

<Route
          path="/buy"
          element={
            <PrivateRoute>
              < BuyProducts />
            </PrivateRoute>
          }
        />

        {/* Redirect all unknown routes to login */}
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/" : "/login"} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
